var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("h1", [_vm._v("儿童个人信息保护政策")]),
      _vm._v(
        "\n    深圳埃努码信息技术有限公司（以下简称“我们”）深知儿童个人信息和隐私安全的重要性，也感谢您对我们的信任，我们将按法律法规要求，采取相应安全保护措施，尽力保护儿童的个人信息安全可控。基于此，我们制定本政策。"
      ),
      _c("br"),
      _vm._v(
        "\n    本政策主要向您阐述我们收集哪些儿童个人信息、所收集儿童信息的用途、儿童信息的保护措施等，并申明了我们对保护儿童个人隐私的承诺。我们未来可能根据信息处理情境的变化更新或修改本政策。\n    请您在使用我们提供的任何服务前知晓本政策和任何补充政策。另有约定外，本政策中所用术语和缩略词与《软件许可及服务协议》、《个人信息保护政策》中的术语和缩略词具有相同的涵义。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n    儿童监护人特别说明："),
      _c("br"),
      _vm._v(
        "\n    如果您是儿童用户的监护人，请您仔细阅读和选择是否同意本政策。我们希望请您与我们共同保护儿童的个人信息，教育引导儿童增强个人信息保护意识和能力，指导、提醒和要求他们在未经您同意的情况下，不向任何网络产品和服务提供者提供任何个人信息。如果您不同意本政策的内容，将导致我们的产品及服务无法正常运行或无法达到预定的服务效果，您应要求您孩子立即停止访问/使用都都产品产品/服务。您孩子使用或继续使用都都产品服务，提交个人信息，都表明您同意我们按照本政策（包括更新版）收集、使用存储和分享您孩子的个人信息。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n    儿童特别说明："),
      _c("br"),
      _vm._v(
        "\n    如果您是 14 周岁以下的儿童，您需要和您的监护人一起仔细阅读本声明，并在征得您的监护人同意后，使用我们的产品、服务或向我们提供信息。如果您使用或继续使用都都产品服务，提交个人信息，都表示您已经获得监护人的许可，您和您的监护人均同意我们按照本政策收集、使用、储存和分享您的个人信息。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n    本政策适用于埃努码公司提供服务的所有产品及服务，包括且不仅限于："
      ),
      _c("br"),
      _vm._v(
        "\n    应用程序：都都数学, 都都英语，都都思维，都都GO，都都kids，都都one，都都家长服务，都都服务；"
      ),
      _c("br"),
      _vm._v("\n    网站：enuma.cn, todomath.cn, todokids.cn, todoone.cn;"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n    我们将恪守以下原则，保护儿童的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、公开透明原则、确保安全原则、主体参与原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护儿童的个人信息。 我们将恪守以下原则，保护儿童的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、公开透明原则、确保安全原则、主体参与原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护儿童的个人信息。"
      ),
      _c("br"),
      _vm._v(
        "\n    当儿童使用任何我们的服务时，监护人同意接受本政策，如本政策与《软件许可及服务协议》、《个人信息保护政策》的同类条款之约定存在不一致的，以本政策为准。未尽事宜以《个人信息保护政策》为准。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n    我们提醒您，本声明中与您和您监护的儿童的权益（可能）密切相关的重要条款，我们已采用加粗字体来特别提醒您，请您重点查阅。"
      ),
      _c("br"),
      _vm._v(
        "\n    如您对本政策内容有任何疑问、意见或建议，请通过文末的方式与我们联系。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n    本政策将帮助您了解以下内容："),
      _c("br"),
      _vm._v("\n    一、我们如何使用和收集儿童个人信息"),
      _c("br"),
      _vm._v("\n    二、我们如何使用 Cookie 和同类技术"),
      _c("br"),
      _vm._v("\n    三、我们如何共享、转让、公开披露儿童的个人信息"),
      _c("br"),
      _vm._v("\n    四、我们如何保护和保存儿童的个人信息"),
      _c("br"),
      _vm._v("\n    五、监护人和儿童的权利"),
      _c("br"),
      _vm._v("\n    六、儿童个人信息如何在全球范围转移"),
      _c("br"),
      _vm._v("\n    七、本隐私政策如何更新"),
      _c("br"),
      _vm._v("\n    八、争议解决"),
      _c("br"),
      _vm._v("\n    九、如何联系我们"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n    本版发布日期：2024 年【10】月【29】日"),
      _c("br"),
      _vm._v("\n    生效日期：2024 年【10】月【29】日"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("一、我们如何使用和收集儿童的个人信息")]),
      _vm._v(
        "\n    我们会出于本政策所述的以下目的，在征得监护人同意后，收集和使用以下类型的儿童个人信息："
      ),
      _c("br"),
      _vm._v("\n    1. 帮助您成为我们产品的用户"),
      _c("br"),
      _vm._v("\n    如儿童想要注册成为都都应用程序的用户，儿童需要提供"),
      _c("b", [_vm._v("电话号码")]),
      _vm._v("作为基本注册或登录信息，并可以选择是否填写"),
      _c("b", [_vm._v(" 昵称、年龄等基本信息，并创建用户账号和密码。")]),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n    2 、向您提供产品或服务"),
      _c("br"),
      _vm._v("\n    （1）用户体验改进计划"),
      _c("br"),
      _vm._v(
        "\n    当您使用都都应用程序过程中，为保障您正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障您的账号安全，我们会收集您的"
      ),
      _c("b", [_vm._v("设备类型")]),
      _vm._v(
        "，这类信息是为提供服务必须收集的基础信息。随着都都产品的后续版本升级，我们统计的范围会有所改变，"
      ),
      _c("b", [
        _vm._v(
          "儿童下载/安装/使用我们后续版本产品的行为将被视为监护人和儿童对届时相关改变的同意。"
        ),
      ]),
      _c("br"),
      _vm._v("\n    （2）开展营销活动"),
      _c("br"),
      _vm._v("\n    当儿童选择参加我们举办的有关营销活动时，根据活动需要可能"),
      _c("b", [_vm._v("使用到儿童提供个人信息与第三方支付服务账号。")]),
      _vm._v("这些信息可能包括"),
      _c("b", [_vm._v("儿童个人敏感信息")]),
      _vm._v(
        "，是儿童收到礼品所必要的。如果儿童拒绝提供这些信息，我们将可能无法向儿童发放礼品。 "
      ),
      _c("b", [
        _vm._v("儿童在参加营销活动之前，需确保已经取得监护人的授权同意。"),
      ]),
      _c("br"),
      _vm._v("\n    （3）客服与售后"),
      _c("br"),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "我们的客服和售后功能会使用儿童的账号信息以为儿童提供咨询服务。"
        ),
      ]),
      _c("br"),
      _vm._v(
        "\n    当监护人和儿童与我们联系时，我们可能会保存儿童的通信或通话记录和内容或儿童留下的联系方式，以便帮助儿童或监护人解决问题，或记录相关问题的处理方案及结果。我们的客服会使用儿童的账号信息与儿童核验身份。监护人和儿童有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息。"
      ),
      _c("br"),
      _vm._v("\n    （4）基础业务功能和附加业务功能"),
      _c("br"),
      _vm._v(
        "\n    注册/ 登录：您在使用都都产品之前，需要先完成注册和登录。注册都都产品账号时您需要提供电话号码，同时用户可以自行选择是否填写姓名或昵称。我们仅根据用户所选难度等级展示不同使用内容和知识点。"
      ),
      _c("br"),
      _vm._v(
        "\n    查看和编辑资料：您可以在都都产品内查看会员信息，选择是否完善或更改您的使用者资料。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n    3.  提供安全保护保障"),
      _c("br"),
      _vm._v(" "),
      _c("b", [
        _vm._v("儿童的网络身份标识信息帮助儿童维护软件正常使用及使用安全。"),
      ]),
      _c("br"),
      _vm._v(
        "\n    儿童可以开放设备麦克风权限来进行语音输入，在此过程中我们使用儿童的语音内容，并对使用数据进行必要的处理以满足儿童的软件使用需求。"
      ),
      _c("br"),
      _vm._v(
        "\n    我们会根据儿童在软件安装及使用中授予的具体权限，接收并记录儿童的个人常用设备信息："
      ),
      _c("b", [
        _vm._v(
          "例如 操作系统版本、设备标识符（AndroidID/IMEI/OAID/IMSI/IDFA） ）软硬件特征信息、 设备所在位置的相关信息（IP地址），IDFA（仅限IOS），Android ID（仅限安卓），国家（仅）位置，使用语言。"
        ),
      ]),
      _c("br"),
      _vm._v(
        "\n    我们可能会收集、使用或整合使用者账户信息、交易信息、设备信息、日志信息以及我们取得授权或依据法律共享的信息，来综合判断使用者账户及交易风险，进行儿童或监护人的身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。"
      ),
      _c("br"),
      _vm._v(
        "\n    儿童个人信息匿名化处理：在收集到儿童个人信息后，我们将通过技术手段及时对数据进行匿名化处理。我们将儿童匿名化后的数据与可用于回复识别个人的信息分开存储，并保证在后续的个人信息处理中不重新识别个人。匿名化后的信息将无法识别特定儿童的身份， 在不泄露儿童 个人信息的前提下，我们有权对匿名化处理后的用户数据库进行挖掘、分析和利用（包括商业性使用）。在不泄露儿童个人信息的前提下，我们有权对匿名化处理后的用户数据库进行挖掘、分析和利用（包括商业性使用）。"
      ),
      _c("br"),
      _vm._v("\n\n    4.  征得授权同意的例外"),
      _c("br"),
      _vm._v(
        "\n    以下情形中，我们收集、使用个人信息不必征得儿童及监护人的授权同意："
      ),
      _c("br"),
      _vm._v("\n    （a) 与个人信息控制者履行法律法规规定的义务相关的；"),
      _c("br"),
      _vm._v("\n    （b）与国家安全、国防安全直接相关的；"),
      _c("br"),
      _vm._v("\n    （c）与公共安全、公共卫生、重大公共利益直接相关的；"),
      _c("br"),
      _vm._v("\n    （d）与刑事侦查、起诉、审判和判决执行等直接相关的；"),
      _c("br"),
      _vm._v(
        "\n    （d）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；"
      ),
      _c("br"),
      _vm._v("\n    （f）所收集的个人信息是您自行向社会公众公开的；"),
      _c("br"),
      _vm._v(
        "\n    （g）从合法公开披露的信息中收集个人信息的，如：合法的新闻报道、政府信息公开等渠道；"
      ),
      _c("br"),
      _vm._v("\n    （h）根据您的要求签订和履行合同所必需的；"),
      _c("br"),
      _vm._v(
        "\n    （i）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现或处置产品或服务的故障；"
      ),
      _c("br"),
      _vm._v(
        "\n\n    5、 我们服务中的部分功能可能需要儿童在设备中开启特定的访问权限（例如麦克风或话题），以实现这些权限所涉及信息的收集和使用。当儿童和监护人需要关闭该功能时，大多数移动设备都会支持该项需求，具体方法请参考或联系设备的服务商或生产商。 当设备被开启任一权限即代表监护人授权我们可以收集和使用相关信息来为儿童提供对应的服务，一旦设备关闭任一权限即代表监护人取消了授权，我们将不再基于对应的权限继续收集和使用相信息，也无法为儿童提供该权限所对应的服务。但是，关闭权限的决定不影响此前基于监护人授权所进行的信息收集及使用。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("二、我们如何使用 Cookie 和同类技术")]),
      _vm._v(
        "\n    为使儿童获得更轻松的访问体验，儿童访问都都网站时，我们可能会通过采用各种技术收集和存储儿童访问都都产品的相关数据，这样可以识别儿童的身份，帮儿童省去重复输入注册信息的步骤，或者帮助判断儿童的账户安全状态。这些数据文件可能是 Cookie、clickstream、web和同类技术，儿童的浏览器或关联应用程序提供的其他本地存储（以下简称“Cookie”）。请监护人和儿童理解，我们的某些服务只能通过使用 Cookie 才可得到实现。如儿童的浏览器或浏览器附加服务允许。多数浏览器工具条中的“帮助”部分会告诉儿童怎样防止儿童的浏览器接受新的 Cookie，怎样让儿童的浏览器在儿童收到一条新 Cookie 时通知监护人和儿童或者怎样彻底关闭 Cookie。监护人和儿童可以通过改变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或删除浏览器附加程序使用的 Flash Cookie 及类似数据。监护人和儿童可以修改对 Cookie 的接受程度或者拒绝都都网站的 Cookie。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("三、我们如何共享、转让、公开披露儿童的个人信息")]),
      _vm._v("\n    （一）共享"),
      _c("br"),
      _vm._v(
        "\n    我们不会与除我们及我们的关联方以外的任何公司、组织和个人共享儿童的个人信息，但以下情况除外："
      ),
      _c("br"),
      _vm._v("\n    1. 事先获得监护人明确的同意或授权；"),
      _c("br"),
      _vm._v(
        "\n    2. 根据法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下对外提供；"
      ),
      _c("br"),
      _vm._v(
        "\n    3. 符合与监护人和儿童签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；"
      ),
      _c("br"),
      _vm._v(
        "\n    4. 我们可能会将儿童的个人信息与我们的关联方共享。但我们只会共享必要的儿童个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变儿童个人信息的处理目的，将再次征求监护人的授权同意。"
      ),
      _c("br"),
      _vm._v("\n    5. 应监护人要求处理与他人的纠纷或争议；"),
      _c("br"),
      _vm._v(
        "\n    6. 与授权合作伙伴共享：在法律法规允许的范围内，为维护深圳埃努码信息技术有限公司的合作伙伴、您或其他都都产品用户或社会公众利益、财产或安全免遭损害， 我们仅为实现本隐私政策中声明的目的与授权合同伙伴共同提供某些服务。我们可能会与合作伙伴共享儿童的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享儿童的个人信息，并且只会共享提供服务所必要的个人信息。我们将审慎评估合作方使用共享信息的目的，对合作方的安全保障能力进行综合评估，我们会对合作方获取信息的软件工具开发包进行严格的安全监测，以保护数据安全， 我们的合作伙伴无权将共享的儿童个人信息用于任何其他用途。我们已与合作方签订合同明确双方的义务与责任，明确我们的合作伙伴无权将共享的个人信息用于任何其他用途。对于无法签订合同的合作方在使用过程中对用户造成影响的，深圳埃努码信息技术有限公司将承担全部责任。"
      ),
      _c("br"),
      _vm._v("\n    我们的授权合作伙伴包括以下类型："),
      _c("br"),
      _vm._v(
        "\n    （1）商品或技术服务的供应商。我们可能会将儿童的个人信息共享给支持我们功能的第三方。这些支持包括为我们提供支付服务、数据处理等。我们共享这些信息的目的是可以实现我们产品与/或服务的核心功能；"
      ),
      _c("br"),
      _vm._v(
        "\n    （2）我们仅会出于合法、正当、必要、特定、明确的目的共享儿童个人信息，对我们与之共享儿童个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理儿童个人信息。"
      ),
      _c("br"),
      _vm._v("\n    （二）转让"),
      _c("br"),
      _vm._v(
        "\n    我们不会将儿童的个人信息转让给任何公司、组织和个人，但以下情况除外："
      ),
      _c("br"),
      _vm._v("\n    1. 事先获得监护人明确的同意或授权；"),
      _c("br"),
      _vm._v(
        "\n    2. 根据法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；"
      ),
      _c("br"),
      _vm._v(
        "\n    3. 符合与监护人和儿童签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；"
      ),
      _c("br"),
      _vm._v(
        "\n    4. 在涉及合并、收购、资产转让或类似的交易时，如涉及到儿童个人信息转让，我们会要求新的持有儿童个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向监护人征求授权同意。"
      ),
      _c("br"),
      _vm._v("\n    （三）公开披露"),
      _c("br"),
      _vm._v(
        "\n    我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露儿童的个人信息："
      ),
      _c("br"),
      _vm._v(
        "\n    1. 根据监护人或儿童的需求，在监护人明确同意的披露方式下披露其所指定的个人信息。"
      ),
      _c("br"),
      _vm._v(
        "\n    2. 根据法律、法规的要求、强制性的行政执法或司法要求所必须提供儿童个人信息的情况下，我们可能会依据所要求的儿童个人信息类型和披露方式公开披露儿童的个人信息。 在符合法律法规的前提下，当我们收到上述披露信息的请求时候，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们对所有请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门特定调查目的且有合法权利获取的数据。"
      ),
      _c("br"),
      _vm._v(
        "\n    （四）共享、转让、公开披露儿童个人信息时事先征得授权同意的例外"
      ),
      _c("br"),
      _vm._v("\n    （a)与个人信息控制者履行法律法规规定的义务相关的；"),
      _c("br"),
      _vm._v("\n    （b）与国家安全、国防安全直接相关的；"),
      _c("br"),
      _vm._v("\n    （c）与公共安全、公共卫生、重大公共利益直接相关的；"),
      _c("br"),
      _vm._v("\n    （d）与刑事侦查、起诉、审判和判决执行等直接相关的；"),
      _c("br"),
      _vm._v(
        "\n    （d）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；"
      ),
      _c("br"),
      _vm._v("\n    （f）您自行向社会公众公开的个人信息；"),
      _c("br"),
      _vm._v(
        "\n    （g）从合法公开披露的信息中收集个人信息的，如：合法的新闻报道、政府信息公开等渠道。"
      ),
      _c("br"),
      _vm._v(
        "\n    根据法律规定，共享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将 无需另行向监护人通知并征得监护人同意。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("四、我们如何保护和保存儿童的个人信息")]),
      _vm._v("\n    （一）我们保护您个人信息的技术与措施"),
      _c("br"),
      _vm._v(
        "\n    1. 我们已使用符合业界标准的安全防护措施保护儿童提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护儿童的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问儿童个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护儿童个人信息重要性的认识。"
      ),
      _c("br"),
      _vm._v(
        "\n    2. SSL（Secure Socket Layer）协议加密保护。当儿童从设备或浏览器向我们的服务器发送或\n    收取信息时，我们确保使用安全套接层（SSL）和其他算法对其进行加密。"
      ),
      _c("br"),
      _vm._v(
        "\n    3. 我们会采取一切合理可行的措施，确保未收集无关的儿童信息。我们会以“最小化”原则收集、使用、存储和传输用户信息，并通过用户协议和隐私政策告知您相关信息的使用目的和范围。"
      ),
      _c("br"),
      _vm._v(
        "\n    4. 儿童的个人信息全都被储存在安全的服务器上，并在受控设施中受到保护。我们依据重要性和敏感性对您的数据进行分类，并且保证儿童的个人信息具有最高的安全等级。 我们以最小授权为原则，仅允许有必要知晓这些信息的员工、合作伙伴访问儿童个人信息，并为此设置了严格的访问权限控制和监控机制。我们保证通过访问这些信息来帮助向儿童提供产品和服务的员工和第三方服务供应商具有严格的合同保密义务，如果未能履行这些义务，其将会受到纪律处分或被终止合作。同样，我们对以云为基础的数据存储设有专门的访问控制措施。总而言之，我们定期审查信息收集、储存和处理实践，包括物理安全措施，以防止任何未经授权的访问和使用。尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请理解，由于技术的限制以及可能存在的各种 恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保儿童提供给我们的个人信息的安全性。您知悉并理解，儿童接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议监护人和儿童采取积极措施保护儿童个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等儿童个人信息透露给他人。我们将对于儿童个人数据的泄露，及时通知相关的监管机构，并在一些特别的环境下，通知数据主体相关的数据泄露事件，以满足适用的相关法律，包括监护人和儿童所在地的数据保护法规。我们不对有可能进入第三方网站的隐私政策的合法性负责，监护人和儿童应检查第三方网站的隐私政策并确定是否接受。"
      ),
      _c("br"),
      _vm._v(
        "\n    5. 在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求【并最迟不迟于 15 个自然日内】向监护人和儿童告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、监护人和儿童可自主防范或降低风险的建议、补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知监护人和儿童，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。"
      ),
      _c("br"),
      _vm._v(
        "同时，我们还将按照监管部门要求，上报儿童个人信息安全事件的处置情况。"
      ),
      _c("br"),
      _vm._v("\n    （二）我们如何保存儿童的个人信息"),
      _c("br"),
      _vm._v(
        "\n    1. 保存期限：我们只会在达成本政策所述目的所需的期限内保留儿童的个人信息，除非法律有强制的留存要求，我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准："
      ),
      _c("br"),
      _vm._v(
        "\n    a.完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；"
      ),
      _c("br"),
      _vm._v("\n    b.保证我们为您提供服务的安全和质量；"),
      _c("br"),
      _vm._v("\n    c.您是否同意更长的留存期间；"),
      _c("br"),
      _vm._v("\n    d.是否存在保留期限的其他特别约定。"),
      _c("br"),
      _vm._v(
        "\n    在超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("五、监护人和儿童的权利")]),
      _vm._v(
        "\n    监护人和儿童可以通过都都应用程序查看、访问我们收集的关于儿童的个人信息，要求修改、删除或拒绝允许进一步收集或使用这些信息，但删除这些信息的请求可能会限制儿童访问所有或部分服务。按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障监护人和儿童对儿童个人信息行使以下权利："
      ),
      _c("br"),
      _vm._v("\n    1.  访问和查询权"),
      _c("br"),
      _vm._v(
        "\n    监护人和儿童有权访问和查询您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问和查询权，可以通过以下方式自行访问查询："
      ),
      _c("br"),
      _vm._v(
        "\n    账户信息：如果监护人和儿童希望访问或编辑账户中的儿童个人资料信息、更改您的密码或关闭账户等，可以通过访问都都产品-个人中心执行此类操作。"
      ),
      _c("br"),
      _vm._v("\n    2.  更正权"),
      _c("br"),
      _vm._v(
        "\n    当您发现我们处理的关于您的个人信息有错误时，您可以直接在我们产品内通过访问【家长系统】-【用户存档】页面直接编辑或更正您的资料信息，包括且不限于修改账号密码、更换绑定的手机号、修改昵称、更换使用等级等。"
      ),
      _c("br"),
      _vm._v("\n    3.  删除权"),
      _c("br"),
      _vm._v(
        "\n    在以下情形中，监护人和儿童可以向我们提出删除个人信息的要求："
      ),
      _c("br"),
      _vm._v("\n    （1）如果我们处理儿童个人信息的行为违反法律法规；"),
      _c("br"),
      _vm._v(
        "\n    （2）如果我们收集、使用儿童的个人信息，却未征得监护人的同意；"
      ),
      _c("br"),
      _vm._v("\n    （3）如果我们处理儿童个人信息的行为违反了约定；"),
      _c("br"),
      _vm._v("\n    （4）如果儿童不再使用我们的产品或服务，或注销了账号；"),
      _c("br"),
      _vm._v("\n    （5）如果我们不再为儿童提供产品或服务；"),
      _c("br"),
      _vm._v(
        "\n    （6）若我们决定响应监护人和儿童的删除请求，我们还将同时通知从我们获得儿童的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得监护人的独立授权。"
      ),
      _c("br"),
      _vm._v(
        "\n    如您希望删除您和/或您孩子的个人信息，您可以通过本政策文末提供的联系方式联系我们，我们将在核实您的身份后及时响应您的请求。"
      ),
      _c("br"),
      _vm._v(
        "\n    您在此同意，若我们响应并完成您的删除请求，您和/或您孩子的个人信息将被删除。我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权当儿童被从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。"
      ),
      _c("br"),
      _vm._v("\n    4.  撤回同意权"),
      _c("br"),
      _vm._v(
        "\n    监护人可以直接通过以下方式撤回收集、使用个人信息的同意授权。撤回同意后，我们后续不会再处理您的个人信息。在我们对外共享、转让、公开披露您的个人信息时，我们会向您提供撤回同意的通知。 撤回同意不影响撤回前基于同意的您的个人信息处理。"
      ),
      _c("br"),
      _vm._v(
        "\n    （a）对于可收集儿童信息的权限（麦克风），在隐私政策中提供收集系统层面的撤回授权方法（设置-应用-权限管理）；"
      ),
      _c("br"),
      _vm._v(
        "\n    撤回同意后，我们后续不会再处理儿童的个人信息。在我们对外共享、转让、公开披露儿童的个人信息时，我们会向监护人和儿童提供撤回同意的通知。 当监护人和儿童撤回授权后，我们无法继续提供撤回授权所对应的服务，也不再处理相应的信息。但撤回同意授权不影响撤回前基于监护人和儿童同意儿开展的个人信息处理。"
      ),
      _c("br"),
      _vm._v("\n    5.  注销权"),
      _c("br"),
      _vm._v(
        "\n    监护人和儿童登录 App 后若需要注销帐号，可以打开都都产品 App 进入家长模式-我的账号-设置齿轮，点击“注销帐号”进行在线申请注销帐号服务，我们将安排专业人员响应注销需求并在 7 个工作日内完成注销处理。在注销帐号之后，我们将停止为您提供产品或服务，并根据适用法律的要求删除您的个人信息，或对其进行匿名化处理。"
      ),
      _c("br"),
      _vm._v("\n    6.  公开与分享"),
      _c("br"),
      _vm._v(
        "\n    我们的服务可让儿童与所有使用该服务的用户公开分享其相关信息，例如儿童在都都产品中所上传或发布的信息、儿童对其他人上传或发布的信息作出的回应，或在都都产品不特定用可见的公开区域内上传或公布儿童的信息，以及包括与这些信息有关的位置数据和日志信息。只要监护人和儿童不删除其所公开或共享的信息，有关信息可能一直存留在公众领域，即使监护人和儿童删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由第三方用户或该等第三方在公众领域保存。 如监护人和儿童将信息通过上述渠道公开或共享，由此造成的信息泄露，我们不承担责任。因此，我们提供并请监护人和儿童慎重考虑是否通过上述渠道公开或共享信息。"
      ),
      _c("br"),
      _vm._v("\n    7. 获取个人信息副本"),
      _c("br"),
      _vm._v("\n    监护人可通过以下路径获取个人信息副本："),
      _c("br"),
      _vm._v(
        "\n    监护人有权登录“都都应用程序获取个人信息，并通过截屏获取个人信息副本。"
      ),
      _c("br"),
      _vm._v("\n    8.  响应上述请求"),
      _c("br"),
      _vm._v(
        "\n    如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息，或您认为都都产品存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过本协议下方的方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的 15 天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。"
      ),
      _c("br"),
      _vm._v("\n    在以下情形中，按照法律法规要求，我们将无法响应您的请求："),
      _c("br"),
      _vm._v("\n    （1）与个人信息控制者履行法律法规规定的义务相关的；"),
      _c("br"),
      _vm._v("\n    （2）与国家安全、国防安全有关的；"),
      _c("br"),
      _vm._v("\n    （3）与公共安全、公共卫生、重大公共利益有关的；"),
      _c("br"),
      _vm._v("\n    （4）与刑事侦查、起诉和审判等有关的；"),
      _c("br"),
      _vm._v(
        "\n    （5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；"
      ),
      _c("br"),
      _vm._v(
        "\n    （6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"
      ),
      _c("br"),
      _vm._v(
        "\n    （7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；"
      ),
      _c("br"),
      _vm._v("\n    （8）涉及商业秘密的。"),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("六、儿童的个人信息如何在全球范围转移")]),
      _vm._v(
        "\n    我们在中华人民共和国境内运营中收集和产生的儿童个人信息，存储在中国境内，我们不会将您的个人信息转移至境外。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("七、本隐私政策如何更新")]),
      _vm._v(
        "\n    我们的隐私政策可能变更。本政策为《软件许可及服务协议》、《个人信息保护政策》的重要组成部分。我们保留不时更新或修改本政策的权利。如果该等修改造成儿童在本政策下权利的实质减少（即“重大变更”），我们会通过不同渠道向监护人和儿童发送变更通知，包括但不限于网站公示、私信通知等方式。若监护人不同意修改后的隐私政策，有权并应立即停止使用都都产品的服务。如果儿童仍继续使用我们的服务，则视为监护人已经充分阅读、理解并接受我们对本政策相关条款所做的修改。"
      ),
      _c("br"),
      _vm._v("\n    本政策所指的重大变更包括但不限于："),
      _c("br"),
      _vm._v(
        "\n    1. 我们的服务模式发生重大变化。如处理儿童个人信息的目的、处理的儿童个人信息类型、儿童个人信息的使用方式等；"
      ),
      _c("br"),
      _vm._v(
        "\n    2. 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；\n    3. 儿童个人信息共享、转让或公开披露的主要对象发生变化；"
      ),
      _c("br"),
      _vm._v(
        "\n    4. 监护人和儿童参与个人信息处理方面的权利及其行使方式发生重大变化；"
      ),
      _c("br"),
      _vm._v(
        "\n    5. 我们负责处理儿童个人信息安全的责任部门、联络方式及投诉渠道发生变化；"
      ),
      _c("br"),
      _vm._v("\n    6. 儿童个人信息安全影响评估报告表明存在高风险时；"),
      _c("br"),
      _vm._v("\n    7. 我们还会将本政策的旧版本存档，供监护人和儿童查阅。"),
      _c("br"),
      _vm._v(
        "\n    在我们停止服务时，我们会及时停止继续收集儿童个人信息，可能以注意送达或网站公告的形式通知监护人和儿童停止运营的情况，并对儿童的个人信息进行删除或匿名化处理。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("八、争议解决")]),
      _vm._v(
        "\n    本用户协议及监护人和儿童与深圳埃努码信息技术有限公司的关系适用于中华人民共和国大陆地区法律，但不包括其冲突法规范。监护人和深圳埃努码信息技术有限公司同意服从深圳埃努码信息技术有限公司所在地法院的司法管辖。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("九、如何联系我们")]),
      _vm._v(
        "\n    我们已经配备个人信息保护专门负责人员，如果您对本隐私政策有任何疑问，或对于您的个人信息处理存在任何投诉、意见，请通过以下方式与我们联系："
      ),
      _c("br"),
      _vm._v("\n    （1）拨打客服电话：（86+）18810316494"),
      _c("br"),
      _vm._v(
        "\n    （2）联系官方客服QQ：2179916770（工作时间：每日9：00-21：30）"
      ),
      _c("br"),
      _vm._v(
        "\n    （3）联系官方微信TodoServer01或微信公众号都都APP，在线咨询人工客服"
      ),
      _c("br"),
      _vm._v("\n    （4）发送邮件至215032956@qq.com。"),
      _c("br"),
      _vm._v(
        "\n    我们将在15个工作日内处理并答复您的投诉与意见。如无法响应您的请求，我们会在法律规定的最大时限要求内，向您发送通知并解释原因。"
      ),
      _c("br"),
      _vm._v(
        "\n    如您对我们的回复不满意，或我们对您和/或您孩子个人信息的处理方式侵害了您和/或您孩子的合法权益，且在您向我们反馈后我们无法提供让您满意的回复且拒绝改进的，您可以向相关监管机构进行投诉和举报。"
      ),
      _c("br"),
      _vm._v(
        "\n    如果您对我们的答复不满意，还可以向消费者权益保护部门投诉或者向有管辖权的法院提诉讼。如果您对我们的答复不满意，还可以向消费者权益保护部门投诉或者向有管辖权的法院提诉讼。"
      ),
      _c("br"),
      _vm._v("\n    深圳埃努码信息技术有限公司"),
      _c("br"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }